import api from './api';

const orderService = {
  // Récupération de toutes les commandes
  getOrders: async (params = {}) => {
    return await api.get('/orders', { params });
  },
  
  // Récupération d'une commande par ID
  getOrderById: async (orderId) => {
    return await api.get(`/orders/${orderId}`);
  },
  
  // Mise à jour d'une commande (admin uniquement)
  updateOrder: async (orderId, orderData) => {
    return await api.put(`/orders/${orderId}`, orderData);
  },
  
  // Annulation d'une commande
  cancelOrder: async (orderId) => {
    return await api.put(`/orders/${orderId}/cancel`);
  }
};

export default orderService;